module.exports = __webpack_public_path__ + "statics/img/FeaturedCases-1.2db02dd2.png";